// 板
import rlModelData from "./rlModelData";
import store from "@/store/index";
import { getEntityData } from "@/rlMxModules/operate/operateApi";
import { McDbPolyline, McCmColor, McGePoint3d } from "mxcad";
import { getPKPM_CantileverSlabData } from "@/rlMxModules/Opencascad/getModelDrawData";
import { rlTextData } from "./rlTextData";
import {
  checkRelationGuidData,
  MovePt,
} from "@/rlMxModules/operate/structural";
class rlCantiSlabData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  // getPKPM_SlabData = store.state.globalData.rl_wasm_module.getPKPM_SlabData;
  constructor() {
    super();
    this.componentType = "cantiSlab";
    this.points = []; // 顶点数据
    this.deviation = 0.00003;
    this.SectData = []; // 截面源数据
    this.m_sectParamData = null;
    this.Thickness = null; // 悬挑板厚度,0 表示同标准层参数

    this.Attribute = 2; // 默认为一般构件

    this._threeObj = null; // 三维图形对象
    this.Color = null;
    this.ModelType = "悬挑板";
    //   (this.rlLayer && this.rlLayer[3] && this.rlLayer[3].storey) || '#00ff66' //构件颜色
    // this.Layer = 'rlSlab' //图层名称

    this.classTypeName = "rlCantiSlab"; // 悬挑板
    this.m_groupName = "rlCantiSlabGroup"; // 组名
    // this.m_useId = null; // 板关联的用途guid
    // this.m_holeArray = []; // 板洞Id集合
    this.isWasmGeted = false; // 是否已经获取wasm数据
    this.m_gridData = {}; // 板关联的网格guid集合--用于pkpm数据导入导出
    this.cantiSlabPoints = []; // 悬挑板点数据
    // 检测鉴定数据--配筋数据
    // this.m_jcData = [];
    // 排查--房间命名
    // this.useFunctionNames = [];
    // 同类构件中主构件的guid
    // this.m_RelationGuid = null;
    // 同类构件数据--临时保存文字
    // this.m_HomogeneousData = [];
    this.m_ez = 0; // 距楼板的距离
    this.m_ec = 0; //水平偏移
    this.m_dr = 0; //布置方向
  }

  initData(obj) {
    super.initData(obj);
    if (!this.Attribute) this.Attribute = 2;
    this.m_gridData = obj.m_gridData;
    this.Thickness = obj.Thickness;
    this.Color = obj.Color;

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.cantiSlabPoints = obj.cantiSlabPoints;
    // this.useFunctionNames = obj.useFunctionNames ? obj.useFunctionNames : [];
    // this.m_RelationGuid = obj.m_RelationGuid ? obj.m_RelationGuid : null;
    this.m_dr = obj.m_dr ? obj.m_dr : 0;
    this.m_ec = obj.m_ec ? obj.m_ec : 0;
    this.m_ez = obj.m_ez ? obj.m_ez : 0;
    //与网格数据绑定
    this.m_gridData.m_cantiSlabId = this.Guid;
  }
  // 用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.Thickness = obj.Thickness;
    // this.m_holeArray = obj.m_holeArray;
    this.m_dr = obj.dr;
    this.m_ec = obj.ec;
    this.m_ez = obj.ez;
    let strPoints = obj.cantiSlabPoints;
    let points2d = strPoints.split(",");
    let points2dData = [];
    if (points2d.length >= 3) {
      for (let i = 0; i < points2d.length; i += 3) {
        points2dData.push(new McGePoint3d(points2d[i], points2d[i + 1], 0));
      }
    }
    this.cantiSlabPoints = points2dData;
    this.m_gridData = getEntityData({
      Guid: obj.m_gridData,
      classTypeName: "rlGrid",
    });
  }

  // 数据转换
  convert() {
    const groupName = this.m_sectParamData.Thick.toString();
    if (
      !this.isWasmGeted ||
      (!this.index2dData && !this.index3dData) ||
      groupName != this.CurrtSect
    ) {
      let currentThick = this.m_sectParamData.Thick;
      if (this.m_sectParamData.Thick == 0 && this.m_gridData) {
        //搜索相邻的楼板，以楼板厚度为准
        const slabIds = this.m_gridData.m_slabIds;
        if (slabIds.length > 0) {
          const slab = getEntityData({
            Guid: slabIds[0],
            classTypeName: "rlSlab",
          });
          if (slab) {
            console.log("slab", slab.Thickness, slab);

            currentThick = slab.Thickness;
          }
        }
      }
      const res = getPKPM_CantileverSlabData(
        this.cantiSlabPoints,
        100,
        currentThick,
        this.LevelB,
        this.Height
      );
      if (!res) return;
      this.Thickness = currentThick;
      this.getModelDrawData(JSON.parse(res));
      // 计算基础数据
      const points = [];
      for (let i = 0; i < this.index2dData.length; i += 3) {
        points.push(this.index2dData[i], this.index2dData[i + 1], 0);
      }
      const lengthDatas = [];
      for (let i = 0; i < points.length; i++) {
        let lastIndex = i + 1;
        if (i == points.length - 1) lastIndex = 0;
        const dist = Math.sqrt(
          points[i] * points[i] + points[lastIndex] * points[lastIndex]
        );
        lengthDatas.push(dist);
      }
      this.OtherData.Length = lengthDatas;

      // let wasmData = JSON.parse(res);
      // let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      // let data3D = this.getModel3dData(data);
      // if (!data3D) return;

      // data3D = JSON.parse(data3D)["3D"][this.Guid];
      // this.points = data3D.Points;
      // this.index3dData = {
      //   points: data3D.Points,
      //   faces: data3D["3dFaces"].map((item) => item.index).flat(),
      // };
    } else {
      if (!Array.isArray(this.index2dData)) {
        this.index2dData = this.index2dData.split(",").map(Number);
      }
    }
  }

  updateThisObj(obj, redraw = true) {
    // console.log("this.m_sectParamData", this.m_sectParamData);
    // console.log("obj.m_sectParamData", obj.m_sectParamData);

    if (redraw) {
      let startPoint = obj.cantiSlabPoints[0];
      let endPoint = obj.cantiSlabPoints[3];
      let pt1 = obj.cantiSlabPoints[1];
      let minPoint = new McGePoint3d(
        (startPoint.x + endPoint.x) / 2,
        (startPoint.y + endPoint.y) / 2,
        0
      );
      let vecX1 = new THREE.Vector3()
        .subVectors(startPoint, endPoint)
        .normalize();
      let vecX2 = new THREE.Vector3(-vecX1.x, -vecX1.y, 0);
      let vecY = new THREE.Vector3().subVectors(pt1, startPoint).normalize();
      let points = [];
      let width = obj.m_sectParamData.Width;
      if (obj.m_sectParamData.Width == 0) {
        let gridStart = new McGePoint3d(...obj.m_gridData.m_stJoint.m_pt);
        let gridEnd = new McGePoint3d(...obj.m_gridData.m_edJoint.m_pt);
        width = gridStart.distanceTo(gridEnd);
      }
      points.push(MovePt(minPoint, vecX1, width / 2));
      points.push(MovePt(points[0], vecY, obj.m_sectParamData.Length));
      points.push(MovePt(points[1], vecX2, width));
      points.push(MovePt(minPoint, vecX2, width / 2));
      this.cantiSlabPoints = points;
    }
    super.updateThisObj(obj, redraw);
  }

  // wasm截面数据转换
  // getModelDrawData(modelData) {
  //   // this.index3dData = modelData["3D"]["3dFaces"]
  //   //   .map((item) => item.index)
  //   //   .flat();
  //   this.index2dData = modelData["2DUpView"];
  //   this.SectData = modelData["SectData"];
  //   this.OtherData = JSON.stringify(modelData);
  // }

  // 删除
  async erase() {
    // 删除用途
    // if (this.m_useId) {
    //   const objtmp = getEntityData({
    //     classTypeName: "rlUse",
    //     Guid: this.m_useId,
    //   });
    //   if (objtmp) objtmp.erase();
    // }
    // 删除关联的网格数据
    this.m_gridData.m_cantiSlabId = null;
    super.erase();
  }

  myClone() {
    const newObj = new rlCantiSlabData();
    super.cloneData(newObj);
    newObj.m_dr = this.m_dr;
    newObj.m_ec = this.m_ec;
    newObj.m_ez = this.m_ez;
    newObj.Thickness = this.Thickness;
    newObj.Color = this.Color;
    newObj.cantiSlabPoints = this.cantiSlabPoints;
    // newObj.useFunctionNames = this.useFunctionNames;
    // newObj.m_RelationGuid = this.m_RelationGuid;
    return newObj;
  }

  // 绘制
  draw() {
    this.convert();
    if (!this.index2dData || !this.index3dData) return;
    if (!this.isWasmGeted) this.isWasmGeted = true;

    console.log("this.Thickness", this.Thickness);

    this.m_sectGroupName = this.Thickness?.toString();
    this.CurrtSect = this.m_sectGroupName;
    //
    // super.draw();
    if (!this.member) {
      // 非点击构件生成才走数据转换
      this.convert();
    }
    if (this.mcDbId) {
      this.mcDbId.getMcDbEntity().erase();
      this.mcDbPolyline = new McDbPolyline();
    }

    this.mcDbPolyline.trueColor = new McCmColor(
      this.Color.r,
      this.Color.g,
      this.Color.b
    );
    this.mcDbPolyline.visible = store.state.displayData.cantiSlabDisplay;
    this.mcDbPolyline.setxDataString("Guid", this.Guid);
    this.mcDbPolyline.setxDataString("classTypeName", this.classTypeName);
    this.mcDbPolyline.drawOrder = 999999;
    this.points = this.index3dData.points;
    if (this.points) {
      this.points = this.points.map((item, index) => {
        if (index % 3 === 2) {
          return item + store.state.cadModules.rlBuilding.LevelB;
        }
        return item;
      });
    }
    this.create2dModel(this.index2dData, this.mcDbPolyline);
    if (!this.index3dData) return;
    this._threeObj = this.create3dModel(
      this.points,
      Array.isArray(this.index3dData)
        ? this.index3dData
        : this.index3dData.faces
    );

    if (this.m_TextObj && this.m_TextObj.mcDbId) {
      this.m_TextObj.mcDbId.getMcDbEntity().textString = this.m_sectGroupName;
    }
  }

  // 返回图形源数据
  getDataBase() {
    const data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;
    data["GridGuid"] = this.m_gridData.Guid;
    // if (!data.OtherData)
    // data["Thickness"] = this.m_sectParamData.Thick;
    data["Shape"] = this.Shape;
    // data["useFunctionNames"] = this.useFunctionNames?.join(",");
    // data["RelationGuid"] = this.m_RelationGuid;
    data["dr"] = this.m_dr;
    data["ec"] = this.m_ec;
    data["ez"] = this.m_ez;
    return data;
  }

  // 获取图形绘制数据--用于撤销回退
  getDrawData() {
    const data = super.getDrawData();

    data["SectGuid"] = this.m_sectParamData.Guid;
    data["Thickness"] = this.m_sectParamData.Thick;
    data["Shape"] = this.Shape;
    data["GridGuid"] = this.m_gridData.Guid;
    data["dr"] = this.m_dr;
    data["ec"] = this.m_ec;
    data["ez"] = this.m_ez;
    let points = [];
    for (let c = 0; c < this.cantiSlabPoints.length; c++) {
      points.push(this.cantiSlabPoints[c].x);
      points.push(this.cantiSlabPoints[c].y);
      points.push(this.cantiSlabPoints[c].z);
    }
    data["cantiSlabPoints"] = points.join(",");
    data["m_gridData"] = this.m_gridData.Guid;
    return data;
  }

  calculateCentroid(points) {
    if (points.length === 0) {
      return null;
    }

    // 计算多边形的边界框
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for (const point of points) {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    }

    // 计算边界框的尺寸
    const width = maxX - minX;
    const height = maxY - minY;
    const minSize = Math.min(width, height);

    // 设置最小边距，为边界框最小尺寸的10%
    const minMargin = minSize * 0.1;

    // 使用多边形面积加权的方法计算重心
    let area = 0;
    let centroidX = 0;
    let centroidY = 0;

    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      const triangleArea = p1.x * p2.y - p2.x * p1.y;
      area += triangleArea;
      centroidX += (p1.x + p2.x) * triangleArea;
      centroidY += (p1.y + p2.y) * triangleArea;
    }

    area = area / 2;

    if (Math.abs(area) < 1e-8) {
      // 如果面积接近0，返回边界框中心点
      return new McGePoint3d((minX + maxX) / 2, (minY + maxY) / 2, 0);
    }

    const factor = 1 / (6 * area);
    centroidX *= factor;
    centroidY *= factor;

    // 检查点是否在多边形内部且距离边缘足够远
    if (
      this.isPointInPolygonWithMargin(centroidX, centroidY, points, minMargin)
    ) {
      return new McGePoint3d(centroidX, centroidY, 0);
    }

    // 如果重心点不满足条件，在多边形内部寻找合适的点
    return this.findSafeInteriorPoint(points, minMargin);
  }

  // 在多边形内部寻找安全的点
  findSafeInteriorPoint(points, margin) {
    // 计算边界框
    let minX = Infinity,
      maxX = -Infinity;
    let minY = Infinity,
      maxY = -Infinity;

    for (const point of points) {
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    }

    // 计算中心点
    const centerX = (minX + maxX) / 2;
    const centerY = (minY + maxY) / 2;

    // 从中心开始，螺旋式向外搜索
    const gridSize = margin / 2;
    let radius = 0;
    const maxRadius = Math.max(maxX - minX, maxY - minY);

    while (radius <= maxRadius) {
      // 在当前半径的圆上采样点
      for (let angle = 0; angle < Math.PI * 2; angle += Math.PI / 8) {
        const x = centerX + radius * Math.cos(angle);
        const y = centerY + radius * Math.sin(angle);

        if (this.isPointInPolygonWithMargin(x, y, points, margin)) {
          return new McGePoint3d(x, y, 0);
        }
      }

      radius += gridSize;
    }

    // 如果螺旋搜索失败，使用网格搜索作为备选方案
    const rows = 10;
    const cols = 10;
    const stepX = (maxX - minX - 2 * margin) / cols;
    const stepY = (maxY - minY - 2 * margin) / rows;

    let bestPoint = null;
    let minDistanceToCenter = Infinity;

    for (let i = 0; i <= rows; i++) {
      for (let j = 0; j <= cols; j++) {
        const x = minX + margin + j * stepX;
        const y = minY + margin + i * stepY;

        if (this.isPointInPolygonWithMargin(x, y, points, margin)) {
          // 计算到中心点的距离
          const distToCenter = Math.sqrt(
            Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)
          );

          if (distToCenter < minDistanceToCenter) {
            minDistanceToCenter = distToCenter;
            bestPoint = { x, y };
          }
        }
      }
    }

    if (bestPoint) {
      return new McGePoint3d(bestPoint.x, bestPoint.y, 0);
    }

    // 最后的备选方案：使用重心
    let centroidX = 0;
    let centroidY = 0;
    let area = 0;

    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      const triangleArea = p1.x * p2.y - p2.x * p1.y;
      area += triangleArea;
      centroidX += (p1.x + p2.x) * triangleArea;
      centroidY += (p1.y + p2.y) * triangleArea;
    }

    area = area / 2;
    if (Math.abs(area) > 1e-8) {
      const factor = 1 / (6 * area);
      centroidX *= factor;
      centroidY *= factor;

      // 如果重心在多边形内且满足边距要求，直接使用重心
      if (
        this.isPointInPolygonWithMargin(centroidX, centroidY, points, margin)
      ) {
        return new McGePoint3d(centroidX, centroidY, 0);
      }
    }

    // 最终备选：三角形重心
    return new McGePoint3d(
      (points[0].x + points[1].x + points[2].x) / 3,
      (points[0].y + points[1].y + points[2].y) / 3,
      0
    );
  }

  // 判断点是否在多边形内部且距离边缘有足够距离
  isPointInPolygonWithMargin(x, y, points, margin) {
    if (!this.isPointInPolygon(x, y, points)) return false;

    // 检查到所有边的距离
    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      const p1 = points[i];
      const p2 = points[j];

      // 计算点到线段的距离
      const distance = this.pointToLineDistance(x, y, p1, p2);
      if (distance < margin) return false;
    }

    return true;
  }
  // 计算点到线段的距离
  pointToLineDistance(x, y, p1, p2) {
    const A = x - p1.x;
    const B = y - p1.y;
    const C = p2.x - p1.x;
    const D = p2.y - p1.y;

    const dot = A * C + B * D;
    const lenSq = C * C + D * D;

    // 参数方程的参数
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;

    let xx, yy;

    if (param < 0) {
      xx = p1.x;
      yy = p1.y;
    } else if (param > 1) {
      xx = p2.x;
      yy = p2.y;
    } else {
      xx = p1.x + param * C;
      yy = p1.y + param * D;
    }

    const dx = x - xx;
    const dy = y - yy;

    return Math.sqrt(dx * dx + dy * dy);
  }
  // 判断点是否在多边形内部
  isPointInPolygon(x, y, points) {
    let inside = false;

    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      const xi = points[i].x;
      const yi = points[i].y;
      const xj = points[j].x;
      const yj = points[j].y;

      // 射线法判断点是否在多边形内部
      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

      if (intersect) inside = !inside;
    }

    return inside;
  }
}

export { rlCantiSlabData };
